module.exports = __webpack_public_path__ + "img/logoElectron.93432d6b.svg";